export const logConfig = {
  // 日志上传使用的接口。支持类型:string。【注意】学科项目一定要配置
  baseURL: '', // 默认值: 'https://dj.xesimg.com/appid/',SaaS(学科)项目需要配置为'https://dj.saasz.vdyoo.com/appid/'

  disableAgif: true, // 禁止一切发往 a.gif 的请求，默认值 false

  // 日志上传的 appid。支持类型:object/string
  appid: '1005554',
  // appid: 'xxxxxxx',    // 2.2.5 版本后兼容 appid string 类型设置，将自动解析 document.domain 作为 referer

  common: {
    // eventid 字段用于指定项目的唯一标识。支持类型:string
    eventid: 'supply-agent-cooperation', // 需自定义。支持类型:string，无默认值
  },

  // 日志上传周期配置。支持类型:object，以下配置为默认值
  cacheUploader: {
    batch: 5, // 日志总量到达5的时候上报一次日志。支持类型:number，默认值:5
    interval: 10000, // 若产生了日志但没达到5条，间隔10秒仍会上传一次日志。支持类型:number，默认值:10000(ms)
  },

  // 交互(interactive)日志相关配置。【注意】需要在日志中心注册交互日志
  clickMsg: {
    open: true, // 交互日志开关。支持类型:boolean,默认值: true
  },

  // 展现(pv)日志相关配置。【注意】需要在日志中心注册展现日志
  loadMsg: {
    open: true, // 展现日志开关。支持类型:boolean，默认值: true
  },

  // hashchange 触发展现日志相关配置
  hashchange: {
    open: true, // hashchange 是否触发展现日志上报。支持类型:boolean，默认值: true
    pvid: 'hash', // pvid 变更模式。支持类型:enum。默认值: 'hash'。配置为 default 时, 只要不刷新 pvid 就保持不变；配置为hash 时, 只要 location.hash 改变，pvid 变化。
    pageuid: {
      // 展现日志、交互日志 pageuid 路由映射。无默认值
      index: 'pageindex', // 首页路由 pageuid 映
      'path/a': 'path/a333',
    },
    loadParam: {
      // 展现日志私有字段路由映射。无默认值
      index: { key1: 'xxx' }, // 首页路由展现日志私有字段映射
      'path/a': { key1: 'zzz' },
    },
  },

  // 手动添加到展现日志、交互日志中的字段，无默认值。字段中的内容将被存入日志内容中
  param: {
    // custom_params: '200021' //示例
  },

  // 以下为配置都为系统(sys)日志相关配置。【注意】需要在日志中心注册系统日志
  // AJAX 网络日志相关配置。
  network: {
    open: true, // 是否上报 AJAX 网络日志。支持类型:boolean，默认值:true
    sample: 1, // 采样率。支持类型:number(取值范围 0-1),默认值:1
    // stopAbortLog: false, // 是否要停止上报用户手动终止(abort)的异步请求。支持类型:boolean,默认值:false，即默认会上报
  },

  // trace相关配置, 推荐打开
  //【注意⭐️⭐️⭐️】打开后可能会造成跨域问题
  trace: {
    // 打开后将在每个请求 header 里都加上 traceid 字段, 需要服务器做该 header 的跨域支持
    // 包含 xueersi、xesv5、vdyoo、xiwang 等域名的 API 网关下, 大部分默认支持该跨域规则
    // 推荐打开该配置
    open: true, // 是否发送 trace 日志并携带 trace头。支持类型:boolean，默认值:false
  },

  // 运行时异常日志相关配置
  runtime: {
    open: true, // 是否上报运行时异常日志。支持类型:boolean,默认值:true
    sample: 1, // 采样率。支持类型:number(取值范围 0-1),默认值:1
  },

  // 资源异常日志相关配置
  resource: {
    open: true, // 是否上报资源异常日志。支持类型:boolean，默认值:true
    sample: 1, // 采样率。支持类型:number(取值范围0-1)，默认值:1
  },

  // 性能日志相关配置
  performance: {
    open: true, // 是否上报性能日志。支持类型:boolean，默认值:true
    sample: 1, // 采样率，支持类型:number(取值范围0-1)，默认值:1
  },

  // uv 为可选参数
  // 如果不传，则使用内部规则随机生成，例如 $s3xet-qYUjC-Ouilb-Hg6pz
  // 如果有，uv 参数类型 string | function
  // uv: () => {
  // 	return Math.random().toString(36).substr(2)
  // }
  // uv: 'NlEGf-6pzKt-yZRal-gGuox'

  vue: {
    errorHandler: true, // 是否捕获 Vue 抛出的错误。支持类型:boolean,默认值:false
  },
};
